import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Robot } from '@phosphor-icons/react';

interface VideoRecordingModalProps {
  videoUrl: string | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function VideoRecordingModal({
  videoUrl,
  open,
  onOpenChange,
}: VideoRecordingModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-6xl w-[90vw]">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Robot className="h-5 w-5" />
            AI Agent Session Recording
          </DialogTitle>
        </DialogHeader>
        <div className="rounded-lg overflow-hidden border bg-black">
          {videoUrl && (
            <video
              autoPlay
              controls
              className="w-full aspect-video"
              src={videoUrl}
            >
              Your browser does not support the video tag.
            </video>
          )}
        </div>
        <p className="text-xs text-muted-foreground text-center">
          This recording shows the AI agent navigating the vendor portal to
          submit the dispute.
        </p>
      </DialogContent>
    </Dialog>
  );
}
